module.exports = __webpack_public_path__ + "static/media/borasvapen.f3f08d56.png";